import baseAPI from '@/http'

const router = 'api/projeto/tarefa'
const routerMunicipioGrupo = 'api/municipio/municipioGrupoSolucao'


export const taskAPI = {
  create: (task) => baseAPI.post(router, task),
  update: (project) => baseAPI.put(router, project),
  delete: (id) => baseAPI.delete(`${router}/${id}`),
  list: () => baseAPI.get(router),
  getTasks: (ids) => baseAPI.post(router + '/get-by-solucoes', ids),
  getBySolucao: (solucao) => baseAPI.post(router + '/get-by-solucao', solucao),
  reabilitarTarefa: (tarefaId) => baseAPI.post(`${routerMunicipioGrupo}/reabilitar-tarefas/${tarefaId}`)

}
